import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar/Navbar';
import Home from './view/Home/Home';
import Signup from './components/Signup/Signup';
import Login from './components/Login/Login';
import About from './view/About/About';
import SummaryBooks from './view/SummaryBooks/SummaryBooks';
import ReadSummary from './view/ReadSummary/ReadSummary';
import AddSummaryBook from './components/AddSummaryBook/AddSummaryBook';
import EditSummaryBook from './components/EditSummaryBook/EditSummaryBook';
import Subscription from './view/Subscription/Subscription';
import Flashcards from './view/Flashcards/Flashcards';
import StudyingBooks from './view/StudyingBooks/StudyingBooks';
import CompletedBooks from './view/CompletedBooks/CompletedBooks';
import ForgetPassword from './view/ForgetPassword/ForgetPassword';
import ResetPassword from './view/ResetPassword/ResetPassword';
import Contact from './view/Contact/Contact';
import AdminMessages from './view/AdminMessages/AdminMessages';
import PaymentResult from './view/PaymentResult/PaymentResult';
import Blog from './view/Blog/Blog';
import BlogPost from './view/BlogPost/BlogPost';

// ========== ایمپورت جدید برای پادکست ==========
import Podcast from './view/Podcast/Podcast';
import ReadPodcast from './view/ReadPodcast/ReadPodcast';
import AddPodcast from './components/AddPodcast/AddPodcast';
import EditPodcast from './components/EditPodcast/EditPodcast';
import AddPodcastEpisode from './components/AddPodcastEpisode/AddPodcastEpisode';
import EditPodcastEpisode from './components/EditPodcastEpisode/EditPodcastEpisode';

function AppContent() {
  const location = useLocation();
  const isReaderPage = location.pathname.startsWith('/read-summary/');

  return (
    <>
      {!isReaderPage && <Navbar />}
      <Routes>
        {/* مسیرهای اصلی */}
        <Route path="/" element={<Home />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/login" element={<Login />} />
        <Route path="/about" element={<About />} />
        <Route path="/summary-books" element={<SummaryBooks />} />
        
        {/* ========== مسیرهای خلاصه کتاب ========== */}
        <Route path="/read-summary/:slug" element={<ReadSummary />} />
        <Route path="/add-summary-book" element={<AddSummaryBook />} />
        <Route path="/edit-summary-book/:id" element={<EditSummaryBook />} />
        
        {/* ========== مسیرهای پادکست ========== */}
        <Route path="/podcast" element={<Podcast />} />
        <Route path="/podcast/:slug" element={<ReadPodcast />} />
        <Route path="/add-podcast" element={<AddPodcast />} />
        <Route path="/edit-podcast/:id" element={<EditPodcast />} />
        <Route path="/add-podcast-episode/:podcastId" element={<AddPodcastEpisode />} />
        <Route path="/edit-podcast-episode/:id" element={<EditPodcastEpisode />} />
        
        {/* مسیرهای دیگر */}
        <Route path="/subscription" element={<Subscription />} />
        <Route path="/flashcards" element={<Flashcards />} />
        <Route path="/studying-books" element={<StudyingBooks />} />
        <Route path="/completed-books" element={<CompletedBooks />} />
        <Route path="/forget-password" element={<ForgetPassword />} />
        <Route path="/reset-password/:token" element={<ResetPassword />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/admin-messages" element={<AdminMessages />} />
        <Route path="/payment-result" element={<PaymentResult />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:slug" element={<BlogPost />} />
      </Routes>
    </>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;